import { dateRenderer, dateSorter, getProp, numericSorter, priceRenderer } from '@lib/generic.utils'
// Components
import LmGridEntityLink from '@components/ag-grid-helpers/EntityLink'

export default {
  computed: {
    actions() {
      if (this.importFile) {
        return [
          {
            label: 'Download import file',
            event: 'download-file',
            type: 'button',
            color: 'tertiary',
            size: 'md'
          }
        ]
      }
      return []
    },
    gridOptions() {
      return {
        rowData: this.agGridRows,
        rowSelection: 'single',
        columnDefs: [
          {
            headerName: 'Subscription name',
            field: 'name',
            tooltipValueGetter: params => (params.value ? params.value : 'N/A'),
            cellRendererParams: params => {
              if (!params || !params.value) return
              return {
                customData: {
                  id: params.data.subscription_id,
                  routeName: 'subscription',
                  label: params.value,
                  newTab: false
                }
              }
            },
            cellRendererFramework: LmGridEntityLink
          },
          {
            headerName: 'Start date',
            field: 'start_date',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'End date',
            field: 'end_date',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Price',
            field: 'price',
            comparator: numericSorter,
            cellRenderer: params => priceRenderer(params.value),
            tooltipValueGetter: params => priceRenderer(params.value)
          },
          {
            headerName: 'Currency',
            field: 'currency',
            tooltipField: 'currency'
          },
          {
            headerName: 'Vendor',
            field: 'vendor',
            tooltipValueGetter: params => getProp(params.value, 'name'),
            cellRendererParams: params => {
              if (!params || !params.value) return
              return {
                customData: {
                  id: getProp(params.value, 'id'),
                  routeName: 'vendor',
                  label: getProp(params.value, 'name'),
                  newTab: false
                }
              }
            },
            cellRendererFramework: LmGridEntityLink
          },
          {
            headerName: 'Publisher',
            field: 'publisher',
            tooltipValueGetter: params => getProp(params.value, 'name'),
            cellRendererParams: params => {
              if (!params || !params.value) return
              return {
                customData: {
                  id: getProp(params.value, 'id'),
                  routeName: 'publisher',
                  label: getProp(params.value, 'name'),
                  newTab: false
                }
              }
            },
            cellRendererFramework: LmGridEntityLink
          }
        ]
      }
    }
  }
}
